import { lazy, ComponentType } from 'react';
import { useRoutes } from 'react-router-dom';
import { ROUTER_ID, routes } from './routes';

const getModuleComponent = (element: ComponentType): { default: ComponentType } => ({ default: element });

const Users = lazy(() => import(/* webpackChunkName: "Users" */ '@/pages/Users').then(module => getModuleComponent(module.Users)));
const User = lazy(() => import(/* webpackChunkName: "User" */ '@/pages/User').then(module => getModuleComponent(module.User)));
const Events = lazy(() => import(/* webpackChunkName: "Events" */ '@/pages/Events').then(module => getModuleComponent(module.Events)));
const SendList = lazy(() => import(/* webpackChunkName: "SendList" */ '@/pages/SendList').then(module => getModuleComponent(module.SendList)));
const Report = lazy(() => import(/* webpackChunkName: "Report" */ '@/pages/Report').then(module => getModuleComponent(module.Report)));
const Archive = lazy(() => import(/* webpackChunkName: "Report" */ '@/pages/Archive').then(module => getModuleComponent(module.Archive)));
const Company = lazy(() => import(/* webpackChunkName: "Report" */ '@/pages/Companies').then(module => getModuleComponent(module.Companies)));

type TUseRouter = () => {
    router: ReturnType<typeof useRoutes>;
};

export const useRouter: TUseRouter = () => {
    const router = useRoutes([
        {
            path: routes.app,
            Component: Events,
        },
        {
            path: routes.archive,
            Component: Archive,
        },
        {
            path: routes.company,
            Component: Company,
        },
        {
            path: routes.sendList + ROUTER_ID,
            Component: SendList,
        },
        {
            path: routes.sendList,
            Component: SendList,
        },
        {
            path: routes.report + ROUTER_ID,
            Component: Report,
        },
        {
            path: routes.users + ROUTER_ID,
            Component: User,
        },
        {
            path: routes.users,
            Component: Users,
        },
    ]);
    return { router };
};
